import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { Project, ButtonStyle } from "@/types/project";
import { useParams } from "react-router-dom";
import { fetchProject } from "@/services/projectsApi";

interface ProjectContextType {
  project: Project | null;
  buttonStyle: ButtonStyle;
  loading: boolean;
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export const ProjectProvider = ({ children }: { children: ReactNode }) => {
  const { projectId } = useParams();
  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(true);

  const defaultButtonStyle: ButtonStyle = {
    style: "default",
    defaultColor: "#3b82f6",
    textColor: "#ffffff",
    exploreButtonradius: 10,
    fontweight: "400",
    fontSize: "16",
    Italic: false,
    Underline: "none",
    buttonBottomPadding: ""
  };

  useEffect(() => {
    const loadProject = async () => {
      if (!projectId) {
        setLoading(false);
        return;
      }

      try {
        const projectData = await fetchProject(projectId);
        setProject(projectData);
      } catch (error) {
        console.error("Error loading project:", error);
      } finally {
        setLoading(false);
      }
    };

    loadProject();
  }, [projectId]);

  return (
    <ProjectContext.Provider
      value={{
        project,
        buttonStyle: project?.buttonStyle || defaultButtonStyle,
        loading,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = (project_id) => {
  const context = useContext(ProjectContext); 
  if (context === undefined) {
    // Return default values if not within ProjectProvider
    return {
      project: null,
      buttonStyle: {
        style: "default" as const,
        defaultColor: "#3b82f6", 
        textColor: "#ffffff",
        hoverTextColor: "#ffffff", 
        exploreButtonradius: 10
      },
      loading: false,
    };
  }
  return context;
};
